import homeApi from "@/api/home";

const BUILTIN_SERVICE_PATH = "/chatlink_builtin.html";

function isSafeCustomerServiceUrl(url) {
  if (typeof url !== "string" || url === "" || url.indexOf("\\") !== -1) {
    return false;
  }

  for (let index = 0; index < url.length; index += 1) {
    const charCode = url.charCodeAt(index);
    if (charCode <= 31 || charCode === 127) {
      return false;
    }
  }

  if (url.charAt(0) === "/") {
    return url.charAt(1) !== "/";
  }

  try {
    const parsed = new URL(url);
    return (
      (parsed.protocol === "http:" || parsed.protocol === "https:") &&
      !!parsed.hostname
    );
  } catch (error) {
    return false;
  }
}

function navigateTo(url) {
  window.location.assign(url);
}

export function openCustomerService() {
  return homeApi
    .customerService()
    .then((response) => {
      const config = response && response.data ? response.data : {};
      const isExternal = config.customer_service_mode === "external";
      const externalUrl = config.customer_service_url;

      if (isExternal && isSafeCustomerServiceUrl(externalUrl)) {
        navigateTo(externalUrl);
        return;
      }

      navigateTo(BUILTIN_SERVICE_PATH);
    })
    .catch(() => {
      navigateTo(BUILTIN_SERVICE_PATH);
    });
}
